<button mat-button
        class="text-neutral-10 group leading-none min-w-max h-[26px] px-[4px] rounded-[4px]"
        [disabled]="sortingDisabled"
        (click)="sortingChange.emit($event)">
  <span class="flex items-center flex-nowrap">
    <span class="label">{{columnName}}</span>

    <!-- sorting icon -->
    @if (!sortingDisabled) {
      <span class="flex"
        [ngClass]="{'text-neutral-60' : sortDirection === SortingEnum.NONE}">
        <svg
          [ngClass]="sortDirection !== SortingEnum.NONE ? 'visible' : 'invisible group-hover:visible'"
          xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24">
          @if (sortDirection === SortingEnum.DESCENDING) {
            <g id="descending_sorting_multi" transform="translate(-989 -34)">
              <g transform="translate(989 34)">
                <path d="M-4,0H-24V24H-4Z" transform="translate(24)" fill="none"/>
                <path d="M0,0V2H12V0ZM0,4V6H8V4ZM0,8v2H4V8Z" transform="translate(4 7.001)"
                      fill="currentColor"/>
                </g>
              @if (sortIndex >= 0 && sortIndex !== null) {
                <text transform="translate(1007 54)" fill="currentColor"
                      font-size="10"
                      font-family="Roobert, sans-serif" font-weight="500">
                  <tspan x="-5.684" y="0">{{sortIndex + 1}}</tspan>
                </text>
              }
              </g>
            } @else {
            <g id="ascending_sorting_multi" transform="translate(-1162 -38)">
                <g transform="translate(1162 38)">
                  <path d="M-4,24H-24V0H-4Z" transform="translate(24)" fill="none"/>
                  <path d="M0,10V8H12v2ZM0,6V4H8V6ZM0,2V0H4V2Z" transform="translate(4 7)"
                        fill="currentColor"/>
                  </g>
              @if (sortIndex >= 0 && sortIndex !== null) {
                <text transform="translate(1180 49)" fill="currentColor"
                      font-size="10"
                      font-weight="500">
                  <tspan x="-5.684" y="0">{{sortIndex + 1}}</tspan>
                </text>
              }
            </g>
            }
            </svg>
          </span>
        }
      </span>

</button>
